export enum GuarantorSummaryRows {
    Construction = 'Construction',
    Bridge = 'Bridge',
    LOC = 'LOC',
    DSCR = 'DSCR',
}
